import { type Middleware } from "openapi-fetch";
import Cookies from "js-cookie";
import router from "@/router";

// Shared auth middleware for every openapi-fetch client (platform_api and the
// feature-flags-server). Attaches the access token + tenant headers and handles
// 401s by bouncing the user back to login.
export const authMiddleware: Middleware = {
  async onRequest({ request }) {
    request.headers.set(
      "Authorization",
      `Bearer ${Cookies.get("access_token")}`,
    );
    request.headers.set("Org-Id", Cookies.get("org_id") ?? "");
    request.headers.set("App-Client-Id", Cookies.get("app_client_id") ?? "");
    const impersonating = Cookies.get("impersonating");
    if (impersonating) {
      request.headers.set("Impersonating", impersonating);
    }
    return request;
  },
  async onResponse({ response }) {
    if (response.status === 401) {
      Cookies.remove("access_token");
      Cookies.remove("refresh_token");
      Cookies.remove("org_id");
      Cookies.remove("app_client_id");
      Cookies.remove("impersonating");

      if (typeof window !== "undefined") {
        const from = window.location.hash.replace(/^#\//, "").trim();
        if (!/^login.*$/.test(from) && !/^signup.*$/.test(from)) {
          router
            .push({
              name: "login",
              query: { from: from },
            })
            .catch(() => {});
        }
      } else {
        console.warn("Received 401 unauthorized in non-browser environment");
      }
    }
    return response;
  },
  async onError({ error }) {
    return Promise.reject(error);
  },
};
